<template>
    <div v-if="store.derechoPolizaEstado === 'cargando'" class="text-muted small mt-2">
        Consultando derecho de póliza…
    </div>
    <div v-else-if="mensaje" class="alert alert-warning d-flex justify-content-between align-items-center mt-2" role="alert">
        <span>{{ mensaje }}</span>
        <button v-if="store.derechoPolizaEstado === 'error'" type="button" class="btn btn-sm btn-outline-secondary"
            @click="store.cargarDerechoPoliza()">
            Reintentar
        </button>
    </div>
</template>

<script>
import { useSeguroStore } from '@/stores/seguroStore';

// Aviso del estado del derecho de póliza en la cotización (sin monto del año, error de consulta).
export default {
    name: 'DerechoPolizaAviso',
    setup() {
        const store = useSeguroStore();
        return { store };
    },
    computed: {
        mensaje() {
            if (this.store.derechoPolizaMensaje) return this.store.derechoPolizaMensaje;
            if (this.store.derechoPolizaEstado === 'idle') return 'Capture la fecha de solicitud para calcular el derecho de póliza.';
            return '';
        },
    },
};
</script>
